<template>
	<div class="residential-order-status">
		<div class="desktop-center" v-if="loggedIn">
			<div class="sk-widget sms-promotion" v-if="showSmsPromotion">
				<div>
					<div>Get 5% Off All Future Orders!</div>
					<div>Subscribe to receive daily menus by SMS</div>
				</div>
				<button
					class="button button-auto button-white"
					@click="promotionCtaClicked"
				>
					Subscribe
				</button>
			</div>
			<div
				class="sk-widget residential-suborder-widget"
				v-for="suborder in suborders"
				:key="suborder.id"
			>
				<div class="sk-widget-header">
					<div>{{ suborder.formattedDate }}</div>
					<div
						class="residential-suborder-status"
						:class="suborder.status | statusClass"
					>
						{{ suborder.status | statusName }}
					</div>
				</div>
				<div class="sk-widget-line-item residential-suborder-line-item">
					<div>
						<div>Meal</div>
						<div class="ellipsify-text">
							{{ suborder.menuName }}
						</div>
					</div>
					<div>
						<div>Delivery</div>
						<div>{{ suborder.formattedTime }}</div>
					</div>
					<div>
						<div>Items</div>
						<div>{{ suborder.itemQuantity }}</div>
					</div>
					<button
						class="button button-transparent button-auto"
						@click="expandSuborder(suborder.id)"
					>
						<i class="sk-icon-chevron-down"></i>
					</button>
				</div>
				<transition-expand>
					<div v-if="expandedSuborders.includes(suborder.id)">
						<CheckoutItem
							v-for="item in suborder.products"
							:key="item.id"
							:item="item"
							:editable="false"
							:showRestaurantName="false"
						/>
					</div>
				</transition-expand>
			</div>
			<section
				class="residential-order-status-section"
				v-if="isVirtualEvent"
			>
				<h1 class="instructions-title">Find Your Food</h1>
				<div class="sk-widget">
					<img
						src="/images/2k-pickup.png"
						alt="Contactless Dropoff Image"
					/>
					<div>
						<h1>Contactless Dropoff</h1>
						<h2>
							{{ pickupInstructions }}
						</h2>
					</div>
				</div>
			</section>
			<section class="residential-order-status-section">
				<h1>Enjoying 2ndKitchen?</h1>
				<h2>Maximize your experience with these awesome perks!</h2>
				<div class="residential-loyalty-perks">
					<div class="sk-widget" v-if="loyaltyCampaign">
						<img src="/images/2k-loyalty.png" alt="Loyalty Image" />
						<div>
							<h1>Earn with Every Order Placed!</h1>
							<h2>{{ loyaltyCampaign.text }}</h2>
							<UserLoyaltyProgress
								:progress="loyaltyCampaign.progress.count"
								:total="loyaltyCampaign.progress.goal"
							/>
						</div>
					</div>
					<div class="sk-widget" v-if="showReferralCampaign">
						<img
							src="/images/2k-referral.png"
							alt="Referral Image"
						/>
						<div>
							<h1>Share and Earn</h1>
							<h2 v-if="referralCampaignProgress">
								{{ referralCampaignProgress }}
							</h2>
							<UserReferral :couponCode="userReferralCoupon" />
						</div>
					</div>
				</div>
			</section>
			<section class="residential-order-status-section">
				<h1>Need Help?</h1>
				<h2>We’re here to help with anything you need!</h2>
				<div class="sk-widget">
					<img
						src="/images/2k-phone.png"
						alt="Contactless Dropoff Image"
					/>
					<div>
						<h1>Questions? Comments?</h1>
						<button
							class="button button-primary button-auto"
							@click="supportClicked"
						>
							Message Support
						</button>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<style scoped>
.instructions-title {
	margin-bottom: 25px;
}

.residential-order-status {
	height: calc(100% - 75px);
	overflow-y: auto;
}

.residential-order-status .desktop-center {
	padding: 20px;
}

.sms-promotion {
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: var(--sk-green);
}

.sms-promotion div {
	color: var(--gR-white);
	font-size: 12px;
}

.sms-promotion > div:first-child > div:first-child {
	font-size: 14px;
	font-weight: 600;
}

.sms-promotion .button {
	color: var(--sk-green);
	font-size: 10px;
	font-weight: 400;
	border: none;
	margin-right: 20px;
}

.residential-suborder-status {
	position: relative;
}

.residential-suborder-status:before {
	content: "";
	position: absolute;
	left: -15px;
	top: 4px;
	width: 7px;
	height: 7px;
	border-radius: 50%;
}

.residential-suborder-ongoing {
	color: var(--sk-green);
}

.residential-suborder-ongoing:before {
	background: var(--sk-green);
}

.residential-suborder-completed {
	color: var(--sk-grey2);
}

.residential-suborder-completed:before {
	background: var(--sk-grey2);
}

.residential-suborder-upcoming {
	color: var(--gR-teal-60);
}

.residential-suborder-upcoming:before {
	background: var(--gR-teal-60);
}

.residential-suborder-widget >>> .checkout-item {
	padding-right: 15px;
	background: var(--sk-offwhite);
}

.residential-order-status-section {
	margin-top: 55px;
}

.residential-order-status-section h1 {
	color: var(--gR-base-90);
	font-size: 14px;
	font-weight: 600;
}

.residential-order-status-section h2 {
	color: var(--sk-grey2);
	font-size: 12px;
	margin-bottom: 25px;
}

.residential-order-status-section .button-primary {
	font-size: 10px;
	padding: 5px 20px;
}

.residential-order-status-section .sk-widget {
	display: flex;
	align-items: center;
	padding: 20px;
	max-width: 490px;
	margin-bottom: 0;
}

.residential-order-status-section .sk-widget > div {
	padding: 0;
	flex: 1;
}

.residential-order-status-section .sk-widget h2 {
	margin-bottom: 0;
}

.residential-order-status-section .sk-widget img {
	width: 50px;
	height: auto;
	margin-right: 20px;
}

.residential-loyalty-perks {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-column-gap: 20px;
}

.residential-loyalty-perks >>> .loyalty-progress {
	margin-top: 13px;
}

@media only screen and (max-width: 1000px) {
	.residential-loyalty-perks {
		grid-template-columns: 1fr;
		grid-row-gap: 20px;
	}
}
</style>

<script>
import { eventBus, EventBusEvents } from "@/eventBus"
import { NotificationType } from "@/enums/NotificationType"
import { MenuType } from "@reef-os/utils/enums/menuType"
import { BusinessEventType } from "@reef-os/utils/enums/businessEventType"
import utils from "@/utils"
import orderSuccessMixin from "@/mixins/order-success-mixin"
import loaderMixin from "@/mixins/loader-mixin"
import userPerksMixin from "@/mixins/user-perks-mixin"
import TransitionExpand from "@/components/common/TransitionExpand.vue"
import CheckoutItem from "@/components/checkout/CheckoutItem.vue"
import UserLoyaltyProgress from "@/components/common/UserLoyaltyProgress.vue"
import UserReferral from "@/components/common/UserReferral.vue"
import moment from "moment"
import "moment-timezone"

const SuborderStatus = {
	UPCOMING: 0,
	ONGOING: 1,
	DELIVERED: 2
}

export default {
	name: "ResidentialOrderStatus",
	mixins: [orderSuccessMixin, loaderMixin, userPerksMixin],
	filters: {
		statusName: function (status) {
			switch (status) {
				case SuborderStatus.UPCOMING:
					return "Upcoming"
				case SuborderStatus.ONGOING:
					return "Ongoing"
				case SuborderStatus.DELIVERED:
					return "Completed"
			}
			return ""
		},
		statusClass: function (status) {
			if (!status) {
				return ""
			}
			switch (status) {
				case SuborderStatus.UPCOMING:
					return "residential-suborder-upcoming"
				case SuborderStatus.ONGOING:
					return "residential-suborder-ongoing"
				case SuborderStatus.DELIVERED:
					return "residential-suborder-completed"
			}
		}
	},
	components: {
		TransitionExpand,
		CheckoutItem,
		UserLoyaltyProgress,
		UserReferral
	},
	data() {
		return {
			expandedSuborders: [],
			timer: ""
		}
	},
	mounted: async function () {
		this.$store.dispatch("setInPurchaseState", false)
		if (!this.$store.state.user || this.$store.state.user.id == 0) {
			const promise = utils.createPromise()
			eventBus.emit(EventBusEvents.OPEN_VERIFY_FLOW, {
				required: true,
				resolve: promise.resolve
			})
			await promise.promise
		}
		if (this.asapSuborder && this.asapSuborder.delivery_job_id) {
			this.$store.dispatch(
				"getDelivery",
				this.asapSuborder.delivery_job_id
			)
		}
	},
	computed: {
		loggedIn() {
			return this.$store.state.user && this.$store.state.user.id != 0
		},
		business() {
			return this.$store.state.business
		},
		menuNames() {
			if (this.business && this.business.menus) {
				return this.business.menus.reduce((names, menu) => {
					names[menu.id] = menu.name
					return names
				}, {})
			}
			return {}
		},
		asapSuborder() {
			if (!this.orderStatus || !this.orderStatus.sub_orders) {
				return false
			}
			return this.orderStatus.sub_orders.find(
				(suborder) => suborder.delivery_slot == null
			)
		},
		suborders() {
			if (!this.orderStatus || !this.orderStatus.sub_orders) {
				return []
			}
			return this.orderStatus.sub_orders.map((suborder) => {
				let quantity = 0
				const products = suborder.products.map((product) => {
					const options = product.meta.reduce((options, meta) => {
						if (!options[meta.key]) {
							options[meta.key] = []
						}
						options[meta.key].push({
							name: meta.value,
							id: `${meta.meta_id}-${meta.meta_val_id}`,
							price: meta.price
						})
						return options
					}, {})
					quantity += product.quantity
					return {
						name: product.name,
						options: options,
						comments: product.comments,
						quantity: product.quantity,
						restaurant_id: suborder.rest_id,
						price: product.subtotal,
						id: product.id
					}
				})

				let formattedDate = ""
				let formattedTime = ""
				let subOrderStatus = null
				if (suborder.delivery_slot) {
					const ongoingStart = moment
						.utc(suborder.delivery_slot)
						.subtract("1", "hour")
					const now = moment().utc()
					subOrderStatus = SuborderStatus.UPCOMING
					if (suborder.delivered_time) {
						subOrderStatus = SuborderStatus.DELIVERED
					} else if (now.isSameOrAfter(ongoingStart)) {
						subOrderStatus = SuborderStatus.ONGOING
					}
					const date = moment
						.utc(suborder.delivery_slot)
						.tz(this.business.timezone)
					formattedDate = date.format("dddd, MMMM D")
					formattedTime = date.format("h a")
				} else {
					const deliveryStatus = this.$store.state.deliveryStatus
					const eta =
						deliveryStatus && deliveryStatus.dropoff_eta
							? deliveryStatus.dropoff_eta
							: null
					formattedDate = "ASAP"
					formattedTime = eta
						? moment
								.utc(eta)
								.tz(this.business.timezone)
								.add(5, "m")
								.format("hh:mm A")
						: "N/A"
				}

				const menuId = suborder.products[0].menu_id
				const menuName = this.menuNames[menuId]
					? this.menuNames[menuId]
					: ""
				return {
					formattedDate: formattedDate,
					formattedTime: formattedTime,
					status: subOrderStatus,
					menuName: menuName,
					itemQuantity: quantity,
					products: products,
					id: suborder.id
				}
			})
		},
		orderEvent() {
			if (
				!this.orderStatus ||
				this.orderStatus.menu_type != MenuType.POPUP ||
				!this.$store.state.business ||
				!this.$store.state.business.menus
			) {
				return null
			}
			const menuId = this.orderStatus.sub_orders[0].products[0].menu_id
			const menu = this.$store.state.business.menus.find(
				(menu) => menu.id == menuId
			)
			if (menu && menu.event_id) {
				return this.$store.state.businessEvents.find(
					(event) => event.id == menu.event_id
				)
			}
			return null
		},
		isVirtualEvent() {
			if (!this.orderEvent) {
				return false
			}
			return this.orderEvent.type == BusinessEventType.VIRTUAL
		},
		pickupInstructions() {
			if (this.isVirtualEvent) {
				const date = moment(
					this.orderEvent.end_date,
					"YYYY-MM-DD"
				).format("dddd, MMMM D")
				const time = moment(
					this.orderEvent.end_time,
					"HH:mm:ss"
				).format("h:mm a")
				return `Your order will be delivered to the ${this.$store.state.business.name} on ${date} at ${time}.`
			}
			return ""
		}
	},
	methods: {
		getOrderStatus: async function () {
			await this.$store.dispatch("getOrderStatus", {
				orderId: this.orderId,
				skipDeliveryStatus: this.asapSuborder ? false : true,
				deliveryJobId: this.asapSuborder
					? this.asapSuborder.delivery_job_id
					: null
			})
			this.getUserPerks()
			this.getBusinessEvent()
		},
		getBusinessEvent() {
			const menuId = this.orderStatus.sub_orders[0].products[0].menu_id
			const menu = this.$store.state.business.menus.find(
				(menu) => menu.id == menuId
			)
			if (menu && menu.event_id) {
				const event = this.$store.state.businessEvents.find(
					(event) => event.id == menu.event_id
				)
				if (!event) {
					this.$store.dispatch("getBusinessEvent", menu.event_id)
				}
			}
		},
		promotionCtaClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "SMS Promotion Clicked"
			})
			this.toggleLoader(true)
			this.$store
				.dispatch("updateUser", {
					smsOptIn: 1
				})
				.then(() => {
					if (this.$store.state.user.smsOptIn == 1) {
						eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
							message: "Hooray! You’re enrolled in 5% off!",
							type: NotificationType.SUCCESS
						})
					} else {
						throw "User not opted in"
					}
				})
				.catch(() => {
					eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
						message: "Something went wrong, please try again.",
						type: NotificationType.ERROR
					})
				})
				.finally(() => {
					this.toggleLoader(false)
				})
		},
		expandSuborder(suborderId) {
			if (this.expandedSuborders.includes(suborderId)) {
				this.expandedSuborders = this.expandedSuborders.filter(
					(id) => id != suborderId
				)
			} else {
				this.expandedSuborders.push(suborderId)
			}
		},
		supportClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Support Clicked"
			})
			eventBus.emit(EventBusEvents.OPEN_SUPPORT_MODAL)
		}
	},
	watch: {
		asapSuborder: {
			immediate: true,
			handler() {
				if (this.timer == "") {
					this.timer = setInterval(this.getOrderStatus, 60000)
				}
			}
		}
	},
	beforeDestroy() {
		clearInterval(this.timer)
	}
}
</script>